import axios from 'axios'
import { promoUrl, getHeader } from '@/config'

const state = {
  promoList: []
}

const mutations = {
  SET_PROMO_LIST (state, obj) {
    state.promoList = obj
  }
}

const actions = {
  getPromoList: ({ commit }) => {
    axios.get(promoUrl, { headers: getHeader() })
      .then(response => {
        commit('SET_PROMO_LIST', response.data.data)
      })
  }
}

export default {
  state, mutations, actions
}
